import { css } from 'linaria';

export const WideButtonClassName = css`
  width: 100%;
`;
